import { View, Text, StyleSheet, TouchableOpacity, Alert } from "react-native";
import { useEffect } from "react";
import LottieView from "lottie-react-native";
import { useNavigation } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { useColors, ThemeColors } from "../../hooks/useColors";
import { spacing, typography } from "../../theme";

const SUCCESS_ANIMATION = require("../../assets/lotties/success.json");

export default function SignUpConfirmationScreen() {
  const navigation = useNavigation();
  const { t } = useTranslation();
  const colors = useColors();
  const styles = createStyles(colors);

  useEffect(() => {
    Alert.alert(
      "Confirm Email",
      t("auth.checkSpamMessage"),
      [{ text: "OK" }]
    );
  }, [t]);

  const handleBackToLogin = () => {
    //@ts-ignore
    navigation.navigate("Auth");
  };

  return (
    <View style={styles.container}>
      <View style={styles.animationContainer}>
        <LottieView
          source={SUCCESS_ANIMATION}
          autoPlay
          loop={true}
          style={{
            width: 300,
            height: 300,
            alignSelf: "center",
          }}
        />
      </View>
      <Text style={styles.title}>{t("auth.checkYourEmail")}</Text>
      <Text style={styles.subtitle}>{t("auth.confirmEmailsBeenSent")}</Text>
      <TouchableOpacity style={styles.backButton} onPress={handleBackToLogin}>
        <Text style={styles.backButtonText}>{t("auth.backToLogin")}</Text>
      </TouchableOpacity>
    </View>
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
    padding: spacing.lg,
    justifyContent: "center",
    alignItems: "center",
  },
  animationContainer: {
    marginBottom: spacing.lg,
  },
  title: {
    ...typography.title,
    fontSize: 24,
    color: colors.primary,
    marginBottom: spacing.sm + 4,
    textAlign: "center",
  },
  subtitle: {
    ...typography.body,
    color: colors.text,
    textAlign: "center",
    marginHorizontal: spacing.sm + 4,
    marginBottom: spacing.lg,
  },
  backButton: {
    backgroundColor: colors.primary,
    paddingHorizontal: spacing.lg,
    paddingVertical: spacing.sm + 4,
    borderRadius: 8,
    alignSelf: "center",
  },
  backButtonText: {
    color: colors.surface,
    fontWeight: "600",
    fontSize: 16,
  },
});
